"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgResetOnPauseOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.reset-on-pause_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "reset-on-pause_outline_svg__transparent_box" },
            React.createElement("path", { className: "reset-on-pause_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "reset-on-pause_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "reset-on-pause_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M16 4h-2.47L16 1.51 14.6.1l-4.95 5 4.95 5L16 8.59 13.43 6H16A10 10 0 116 16a9.92 9.92 0 011.62-5.45l-1.68-1.1A12 12 0 1016 4z" }),
            React.createElement("path", { d: "M13 13h2v6h-2zM17 13h2v6h-2z" }))));
}
exports.default = SvgResetOnPauseOutline;
//# sourceMappingURL=ResetOnPauseOutline.js.map